const backgrounds = {
  canvas: "/bg/comic-canvas.JPG", // Main background canvas (PixiJS)
  panel1: "/bg/panel1.jpg",       // Page 1 background
  panel2: "/bg/panel2.jpg",       // Page 2 background
  panel3: "/bg/panel3.jpg",       // Page 3 background
  panel4: "/bg/panel4.jpg",       // Page 4 background

  feature: [
    "/bg/feature1.JPG",           // Feature card 1
    "/bg/mystical-path.JPG",           // Feature card 2
    "/bg/feature3.JPG",           // Feature card 3
  ],
};

export default backgrounds;